import Columns from '../util/columnConform';
export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fire

        // set window width
        var windowWidth = jQuery(window).innerWidth();

        // Gravity Forms Nice Select
        if (jQuery('.gfield_select').length) {
            jQuery('.gfield_select').addClass('select-box');
        }

        // Animate Gravity Forms
        if (jQuery('.gform_confirmation_wrapper').length) {
            let $id = jQuery('.gform_confirmation_wrapper').attr('id');
            $("html, body").animate({scrollTop: $('#'+$id+'').offset().top }, 1000);
        }

        if (jQuery('.gform_validation_error').length) {
            let $id = jQuery('.gform_validation_error').attr('id');
            $("html, body").animate({scrollTop: $('#'+$id+'').offset().top }, 1000);
        }

        // Mobile detection
        var isMobile = false;

        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

        // Data filters for categories
        if (jQuery('.mobile-filter select.categories-select').length) {
            jQuery('.mobile-filter div.categories-select').attr('data-filter', 'cat');
            jQuery('.mobile-filter div.tags-select').attr('data-filter', 'tag');
        }
        // Select box init
        jQuery('.select-box').niceSelect(); 

        // Active nice select
        if (jQuery('form .nice-select').length) {
            jQuery('form .nice-select').each(function() {
                let activeItem = jQuery(this).find('.list li').first().text();
                jQuery(this).find('.current').text(activeItem);
                // let activeItem = jQuery('form .nice-select .list li').first().text();
                // jQuery('form .nice-select .current').text(activeItem);
            });
        }

        // hide uncategorized filter
        setTimeout(function() {
            jQuery('.categories-select li[data-value="Uncategorized"]').hide();
        }, 400);

        // nice radio btns
        niceRadioButtons();

        // add post to sidebar container
        let $sidebarForm = jQuery('.sidebar-container form');
        $sidebarForm.attr('method', 'post');

        // add post to blog sidebar container
        let $sidebarFormBlog = jQuery('.blog-sidebar form');
        $sidebarFormBlog.attr('method', 'post');

        // Set up the employee directory tab
        let queryString = window.location;
        queryString = queryString.href;
        queryString = queryString.split('#');
        // console.log(queryString);

        if (queryString[1] == 'directory') {
            // console.log('in');
            jQuery('.nav-item a[href="#management"]').removeClass('active');
            jQuery('.nav-item a[href="#directory"]').addClass('active');
            jQuery('#management').removeClass('in active');
            jQuery('#directory').addClass('in active');
        } else if (queryString[1] == 'featured') {
            jQuery('.nav-item a[href="#management"]').removeClass('active');
            jQuery('.nav-item a[href="#featured"]').addClass('active');
            jQuery('#management').removeClass('in active');
            jQuery('#featured').addClass('in active');
        }

        setTimeout(function() {
            var managementBlue = new Columns('#management .info .info-name-title', '#management .info .info-name-title');
            var featuredBlue = new Columns('.management-row.featured .info .info-name-title', '.management-row.featured .info .info-name-title');
            // var columnsMobile = new Columns('.mobile .hp-col-set-height:visible', '.mobile .hp-col-match-height:visible');

            // columnsMobile.equalheight();
            // if (jQuery('.callout-row .callout-col').length) {
            //     columns.equalheight();
            //     columns2.equalheight();
            //     columns3.equalheight();
            // }
            managementBlue.equalheight();
            featuredBlue.equalheight();
            jQuery('#management').addClass('shown');
            let url = window.location.href;
            if(url.indexOf("#") != -1){
                jQuery('#featured').addClass('shown');
            }
            // matchCallouts(jQuery('.callout'), jQuery('.callout-col p'), jQuery('.callout-col h3'));
        }, 1000);

        setTimeout(function() {
            var columns = new Columns('.callout-row .callout-col p', '.callout-row .callout-col p');
            // var columns2 = new Columns('.callout-row .callout-col h3', '.callout-row .callout-col h3');
            var columns3 = new Columns('.callout-row .callout-col', '.callout-row .callout-col');
        
            columns.equalheight();
            // columns2.equalheight();
            columns3.equalheight();

            jQuery('.callout-col').each(function() {
                jQuery(this).addClass('callout-shown');
            });
        }, 1000);

        // load more for news 
        loadMoreNews(jQuery('.blog-container'));

        // show search
        showSearch();

        // blog filter desktop
        blogFilter();

        // activate tooltips
        toolTips();

        // random quote
        randomQuote();

        // random gallery
        randomGallery();

        // add breadcrumb to blog
        addBlogCrumb();

        // change search text 
        changeSearchMoreText();

        // match height blue info boxes our people
        lineUpBlue();

        // remove blog breadcrumb
        blogFilterRemoveCrumb();

        // display directory last name order
        displayDirectory();

        // load more news
        jQuery('.nav-previous a').on('click', function(e) {
            e.preventDefault();
            jQuery(this).parent().fadeOut();
            jQuery('.loading-icon').addClass('shown');
            loadMoreSearch(jQuery(this));  
        });

        jQuery(document).ajaxComplete(function() {
            jQuery('.nav-previous a').on('click', function(e) {
                e.preventDefault();
                jQuery(this).parent().fadeOut();
                jQuery('.loading-icon').addClass('shown');
                loadMoreSearch(jQuery(this));  
            });
        });

        jQuery(document).scroll(function() {
          var y = jQuery(this).scrollTop();
          if (y > 400) {
            jQuery('.back-to-top').fadeIn();
          } else {
            jQuery('.back-to-top').fadeOut();
          }
        });

        jQuery('.back-to-top i').on('click', function() {
            jQuery("html, body").animate({scrollTop: $('#top').offset().top }, 1000);
        });

        // dropdowns
        function dropdownExpanded(e) {
            const link = e.currentTarget;

            if (jQuery(link).attr('aria-expanded') === 'false') {
                jQuery(link).parent('li').addClass('expanded');
            } else {
                jQuery(link).parent('li').removeClass('expanded');
            }
        }
        jQuery('a.parent-link').bind('click', dropdownExpanded);
        
        // select box
        function selectboxExpanded(e) {
            const arrow = e.currentTarget;

            if (jQuery(arrow).parent().children('.nice-select').first().hasClass('open')) {
                jQuery(arrow).parent().children('.nice-select').first().removeClass('open');
            } else {
                jQuery(arrow).parent().children('.nice-select').first().addClass('open');
            }
        }

        jQuery('i.hb-down-dir').bind('click', selectboxExpanded);

        // close links for mobile nav
        var $close = "<li class='close-container extra'><a class='close-link' href='javascript:;'>Close <span>&#10005</span></a></li>";
        var $back = "<li class='back extra'><a class='back-link' href='javascript:;'><span class='back-arrow'>&#10140</span>Back</a></li>";

        $('#menu-primary-menu').prepend($back);
        $('#menu-primary-menu').prepend($close);

        jQuery('#menu-primary-menu li.dropdown').each(function() {
            jQuery(this).append("<div class='arrow-container'><i class='down-arrow'>&#59395</i><i class='down-arrow-open'>&#59394</i></div>");
        });

        var $contactUsLink = jQuery('#menu-top-bar-menu .menu-contact-us').clone(true);
        jQuery('#menu-primary-menu').append($contactUsLink);

        var $secureEmailLink = jQuery('#menu-top-bar-menu .menu-secure-email').clone(true);
        jQuery('#menu-primary-menu').append($secureEmailLink);

        // functions for filtering of employees
        $('#departments-select-wrapper .nice-select li').bind('click', function() {
            var selectedDepartment = $(this).text();
            var selectedTitle = $('#title-select-wrapper .nice-select .current').text();
            filterHelper(selectedDepartment);
        });

        $('#title-select-wrapper .nice-select li').bind('click', function() {
            var selectedTitle = $(this).text();
            var selectedDepartment = $('#departments-select-wrapper .nice-select .current').text();
            filterHelper(selectedTitle, selectedDepartment);
        });

        $('#sort-select-wrapper .nice-select li').bind('click', function() {
            var sort = $(this).attr('data-value');
            if(sort == "first_a_to_z") {
                sortHelper('first');
            }
            else if(sort == "last_a_to_z"){
                sortHelper('last');
            }
        });

        jQuery('.mobile-filter .nice-select li').bind('click', function() {
            var selectedCat = jQuery(this).text();
            var $type = jQuery(this).parent().parent().attr('data-filter');
            selectedCat = selectedCat.replace(' ', '-');
            selectedCat = selectedCat.replace(' ', '-');
            selectedCat = selectedCat.toLowerCase();
            blogFilterMobile(selectedCat, $type);
        });

        function blogFilter() {
            jQuery('.blog-sidebar a').on('click', function(e){
                e.preventDefault();
                let $curTag = jQuery('.cur-filters .tag').text();
                let $curCat = jQuery('.cur-filters .cat').text();
                // console.log($curCat);
                // console.log($curTag);
                let $tag = jQuery(this).attr('data-tag');
                let $cat = jQuery(this).attr('data-cat');

                if ($curTag.length > 1 && $tag == undefined && $tag != 'all') {
                    $tag = $curTag;
                } 

                if ($curCat.length > 1 && $cat == undefined && $cat != 'all') {
                    $cat = $curCat;
                }
                // console.log($curTag);
                // console.log($tag);
                // console.log($curCat);
                // console.log($cat);

                jQuery('.blog-container').addClass('hide-blog');
                jQuery('.blog-container-filter').addClass('hide-blog');
                jQuery('.load-more-container').hide();
                jQuery('.loading-icon').addClass('show');

                jQuery('.blog-sidebar li').each(function() {
                    jQuery(this).removeClass('active');
                });

                // console.log(jQuery('.blog-sidebar li a[data-cat='+$cat+']'));
                // console.log(jQuery('.blog-sidebar li a[data-cat='+$tag+']'));

                jQuery('.blog-sidebar li a[data-cat='+$cat+']').parent().addClass('active');
                jQuery('.blog-sidebar li a[data-tag='+$tag+']').parent().addClass('active');

                jQuery.ajax({
                    data: {cat: $cat, tag: $tag},
                    url: '/wp-content/themes/henderson_bros/src/lib/blog-news-filter.php',
                    success: function(response) {
                        jQuery('.blog-container-filter').html(response);
                        loadMoreNews(jQuery('.blog-container-filter'));
                    },
                    complete: function() {
                        jQuery('.loading-icon').removeClass('show');
                        jQuery('.blog-container-filter').removeClass('hide-blog');
                        console.log('done');
                    } 
                });
            });
        }

        function blogFilterMobile($filter, $type) {
            blogFilterMobile();
        }

        function blogFilterMobile() {
            setTimeout(function() {
                let $curTag = jQuery('.cur-filters .tag').text();
                let $curCat = jQuery('.cur-filters .cat').text();
                let $tag = jQuery('.tags-select .selected').attr('data-value');
                $tag = $tag.replace(' ', '-');
                $tag = $tag.replace(' ', '-');
                $tag = $tag.toLowerCase();
                if ($tag == 'all-tags') {
                    $tag = 'all';
                }

                let $cat = jQuery('.categories-select .selected').attr('data-value');
                $cat = $cat.replace(' ', '-');
                $cat = $cat.replace(' ', '-');
                $cat = $cat.toLowerCase();
                if ($cat == 'all-categories') {
                    $cat = 'all';
                }

                if ($curTag.length > 1 && $tag == undefined && $tag != 'all') {
                    $tag = $curTag;
                } 

                if ($curCat.length > 1 && $cat == undefined && $cat != 'all') {
                    $cat = $curCat;
                }
                // console.log($curTag);
                // console.log($tag);
                // console.log($curCat);
                // console.log($cat);

                jQuery('.blog-container').addClass('hide-blog');
                jQuery('.blog-container-filter').addClass('hide-blog');
                jQuery('.load-more-container').hide();
                jQuery('.loading-icon').addClass('show');

                jQuery('.blog-sidebar li').each(function() {
                    jQuery(this).removeClass('active');
                });

                // console.log(jQuery('.blog-sidebar li a[data-cat='+$cat+']'));
                // console.log(jQuery('.blog-sidebar li a[data-cat='+$tag+']'));

                jQuery('.blog-sidebar li a[data-cat='+$cat+']').parent().addClass('active');
                jQuery('.blog-sidebar li a[data-tag='+$tag+']').parent().addClass('active');

                // console.log($filter);

                jQuery.ajax({
                    data: {cat: $cat, tag: $tag},
                    url: '/wp-content/themes/henderson_bros/src/lib/blog-news-filter.php',
                    success: function(response) {
                        jQuery('.blog-container-filter').html(response);
                        loadMoreNews(jQuery('.blog-container-filter'));
                    },
                    complete: function() {
                        jQuery('.loading-icon').removeClass('show');
                        jQuery('.blog-container-filter').removeClass('hide-blog');
                        // console.log('done');
                    } 
                });
            }, 400);
        }

        function loadMoreNews($container) {
            let $newsArray = $container.find('.blog-row').toArray();
            // console.log($newsArray);
            let OgArrayLength = $newsArray.length;
            $container.find('.blog-row').hide();
            $container.find('.blog-row:lt(3)').show();
            // $('#showLess').hide();
            let items =  OgArrayLength;
            let shown =  3;
            // console.log(items);
            // console.log(shown);
            if (items > shown) {
                jQuery('.load-more-container').show();
            }
            jQuery('.load').click(function (e) {
                e.preventDefault();
                shown = $container.find('.blog-row:visible').size()+6;
                if(shown < items) {
                    $container.find('.blog-row:lt('+shown+')').show();
                    jQuery('.load-more-container').show();
                } else {
                    $container.find('.blog-row:lt('+items+')').show();
                    jQuery('.load-more-container').hide();
                }
            });
        }

        function filterHelper(selectedDepartment) {
            $('.directory-row').each(function() {
                var hide = true;
                if(selectedDepartment == "All Departments" || selectedDepartment == $(this).find('.department-text').text()) {
                    hide = false;
                    // UNCOMMENT HERE AND ADD IN PARAMETERS TO RE-ENABLE TITLE SORTING
                    // if(selectedTitle == "All Titles" || selectedTitle == $(this).find('.title').text()) {
                    //     hide = false;   
                    // } else {
                    //     hide = true;
                    // } 
                } else {
                    hide = true;
                }
                if(hide) $(this).hide();
                else $(this).show();
            });
        }

        function sortHelper(order) {
            var rows = new Array(500); // name, row
            $('.directory-row').each(function(i) { 
                var name = $(this).find('.name').text().split(' ');
                rows[i] = new Array(2);
                if(order == 'first') rows[i][0] = name[0];
                else rows[i][0] = name[name.length - 1];
                rows[i][1] = $(this)[0].outerHTML;
            });
            rows.sort(sortFunction);
            var row_str = "";
            $('.directory-row').each(function(i) {
                var row_html = rows[i][1];
                row_str += row_html;
            });
            $("#employee-container").html(row_str);
        }

        function sortFunction(a, b) {
            if (a[0] === b[0]) {
                return 0;
            }
            else {
                return (a[0] < b[0]) ? -1 : 1;
            }
        }

       //function for searching employees 
        $('#search-employees').on('input', function(){
            $('.directory-row').each(function(i) {
                var hide = true;
                if($(this).find('.name').text().toUpperCase().indexOf($('#search-employees').val().toUpperCase()) > -1) hide = false;
                if($(this).find('.email').text().toUpperCase().indexOf($('#search-employees').val().toUpperCase()) > -1) hide = false;
                if($(this).find('.phone').text().toUpperCase().indexOf($('#search-employees').val().toUpperCase()) > -1) hide = false;
                if($(this).find('.department').text().toUpperCase().indexOf($('#search-employees').val().toUpperCase()) > -1) hide = false;
                if($(this).find('.title').text().toUpperCase().indexOf($('#search-employees').val().toUpperCase()) > -1) hide = false;
                // take dropdowns into account before hiding/showing people
                // var selectedDepartment = $('#departments-select-wrapper .nice-select .current').text();
                var selectedDepartment = "All Departments";
                var selectedTitle = $('#title-select-wrapper .nice-select .current').text();
                var dropdownHide = true;
                if(selectedDepartment == "All Departments" || selectedDepartment == $(this).find('.department-text').text()) {
                    /*if(selectedTitle == "All Titles" || selectedTitle == $(this).find('.title').text())*/ dropdownHide = false; 
                }
                // hide / show people
                if(hide || dropdownHide) $(this).hide();
                else $(this).show();
            });
            $('#departments-select + .nice-select li').each(function() {
                $(this).removeClass('selected');
            });
            $('#departments-select + .nice-select .current').text('All Departments');
            $('#departments-select + .nice-select .list li:first-child').addClass('selected');

            $('#sort-select + .nice-select li').each(function() {
                $(this).removeClass('selected');
            });
            $('#sort-select + .nice-select .current').text('Last name A to Z');
            $('#sort-select + .nice-select .list li:first-child').addClass('selected');
            sortHelper('last');
        });

        function showSubMenu($parent, $list, $li) {
            setTimeout(function() {
                if ($li.hasClass('ul-shown')) {
                    $li.removeClass('ul-shown');
                } else {
                    jQuery('#menu-primary-menu').css('background-color', 'transparent');
                    $li.siblings().not('.extra').addClass('li-hide');
                    $li.siblings('.back').addClass('li-shown');
                    $li.addClass('ul-shown');
                    // console.log('here');
                }
                jQuery('#menu-primary-menu li.back').on('click', function(ex) {
                    jQuery('#menu-primary-menu').css('background-color', '#00194F');
                    $li.siblings().not('.extra').removeClass('li-hide');
                    $li.siblings('.close-container').removeClass('li-shown');
                    $li.siblings('.back').removeClass('li-shown');
                    jQuery('#menu-primary-menu li').each(function() {
                        jQuery(this).removeClass('ul-shown');
                    });
                });
            }, 400);
        }

        function showSearch() {
            jQuery('.search-container a').on('click', function() {
                jQuery(this).parent().addClass('show-dropdown');
                jQuery('.search-dropdown').addClass('show-dropdown');

                jQuery('.search-container .close-search').on('click', function() {
                    jQuery(this).parent().removeClass('show-dropdown');
                    jQuery('.search-dropdown').removeClass('show-dropdown');
                });
            });
        }

        function niceRadioButtons() {
            jQuery('.contact-us-page .email-check').append('<span class="nice-radio"></span>');
            jQuery('.contact-us-page .phone-check').append('<span class="nice-radio"></span>');
        }

        function toolTips() {
            let tipsArr = [];
            let $i = 0;
            // console.log(tipsArr);
            jQuery('.hidden-tips .tip-container').each(function() {
                // console.log(jQuery(this).find('.tip-term'));
                let $term = jQuery(this).find('.tip-term');
                // console.log($term.text());
                let $def = jQuery(this).find('.tip-def');
                let combined = $term.text() + '--' + $def.text();
                // console.log(combined);
                // console.log($def.text());
                tipsArr.push($i);
                // console.log(tipsArr[$i]);
                // console.log(tipsArr);
                tipsArr[$i] = combined;
                // tipsArr[$i] = $def;
                $i++;
            });
            jQuery.each(tipsArr, function() {
                let singleTip = this.split('--');
                let newTerm = singleTip[0];
                let newDef = singleTip[1];
                // console.log(newTerm);
                // console.log(newDef);
                // console.log(singleTip);
                jQuery('.main-content :not("form"):contains("'+newTerm+'")').html(function(_, html) {
                    // console.log(this);
                    let newTermForRegEx = newTerm.replace(/\(/g, '\\(').replace(/\)/g, '\\)').replace(/\&/g, '\\&amp;');
                    let re = new RegExp(newTermForRegEx, "g");
                    // console.log(re);
                    return html.replace(re, '<span class="tool-tip">'+newTerm+'<span style="visibility:hidden" class="term-definition">'+newDef+'</span><i class="fa fa-info-circle"></i></span>');
                });
            });
        }

        function randomQuote() {
            if (jQuery('.rotating-row').length) {
                let $elems = jQuery('.rotating-quote');
                $elems.hide();
                let rand = $elems[Math.floor(Math.random() * $elems.length)];
                jQuery(rand).fadeIn();
            }
        }

        function randomGallery() {
            // if (jQuery('.gallery-col').length) {
            //     let $i = 0;
            //     let $elems = jQuery('.gallery-col');
            //     while($i < 5) {
            //         $elems.hide();
            //         let rand = $elems[Math.floor(Math.random() * $elems.length)];
            //         jQuery(rand).fadeIn();
            //         $i++;
            //     }
            // }
        }

        function addBlogCrumb() {
            if(jQuery('.single-post').length) {
                jQuery('.last-crumb').before('<span property="itemListElement" typeof="ListItem" class="breadcrumb"><a property="item" typeof="WebPage" title="Go to Blog" href="/our-blog-expert-voice">Our Blog: Expert Voice</a></span></span>');
            }
        }

        function changeSearchMoreText() {
            if (jQuery('.search article').length) {
                jQuery('.search article .entry-summary p a').each(function() {
                    jQuery(this).text('Read More');
                });
            }
        }

        function lineUpBlue() {
            jQuery('.nav-tabs .nav-item a').on('click', function() {
                let id = jQuery(this).attr('href');
                // console.log(jQuery(id + ' .info .info-name-title'));
                setTimeout(function() {
                    let $match = jQuery(id + ' .info .info-name-title');
                    var managementBlue = new Columns($match, $match);
                    managementBlue.equalheight();
                    jQuery(id).addClass('shown');
                }, 500);
            });
        }

        function blogFilterRemoveCrumb() {
            if(jQuery('body.single').length) {
                jQuery('.blog-sidebar a').on('click', function() {
                    if (jQuery('.last-crumb').length) {
                        jQuery('.last-crumb').fadeOut();
                        jQuery('.breadcrumbs > .container span').not(':first-child').addClass('inactive');
                        jQuery('.inactive a').attr('disabled');
                    }
                });
            }
        }

        function matchCallouts(elem1, elem2, elem3) {
            var heights = $(elem1).map(function () {
                return $(this).outerHeight();
            }).get(),

            maxHeight = Math.max.apply(null, heights);
            console.log(maxHeight);

            $(elem1).each(function() {
                jQuery(this).css('height', maxHeight);
            });

            // var heights2 = $(elem2).map(function () {
            //     return $(this).outerHeight();
            // }).get(),

            // maxHeight2 = Math.max.apply(null, heights2);
            // console.log(maxHeight2);

            // $(elem2).each(function() {
            //     jQuery(this).css('height', maxHeight2);
            // });

            // var heights3 = $(elem3).map(function () {
            //     return $(this).outerHeight();
            // }).get(),

            // maxHeight3 = Math.max.apply(null, heights3);
            // console.log(maxHeight3);

            // $(elem3).each(function() {
            //     jQuery(this).css('height', maxHeight3);
            // });
        }

        function loadMoreSearch($btn) {
            let $url = $btn.attr('href');
            console.log($url);
            jQuery.ajax({
                type: 'GET',
                url: $url,
                success: function(response) {
                    let $content = jQuery(response).find('#search-results').html();
                    console.log($content);
                    jQuery('article').last().after($content);
                },
                complete: function() {
                    // jQuery('.loading-icon').removeClass('show');
                    // jQuery('.blog-container-filter').removeClass('hide-blog');
                    // console.log('done');
                    jQuery('.loading-icon').removeClass('shown');
                } 
            });
        }

        function displayDirectory() {
            sortHelper('last');
            $('#employee-container').addClass('shown');
        }

        jQuery('.nice-radio').on('click', function() {
            jQuery('.nice-radio').removeClass('check');
            jQuery(this).addClass('check');
            jQuery(this).siblings('input').attr('checked', 'checked');
            jQuery(this).parent().siblings('span').find('input').removeAttr('checked');
        });

        // Screen size scripts
        if (windowWidth < 768) {
            jQuery('#menu-primary-menu > li i').on('click', function() {
                // console.log(jQuery(this));
                let $list = jQuery(this).parent().siblings('ul');
                let $parent = jQuery(this).parent().parent().parent();
                let $li = jQuery(this).parent().parent();
                // console.log($list);
                // console.log($parent);
                // console.log($li);
                showSubMenu($parent, $list, $li);
                // console.log(jQuery(this));
            });
            jQuery('#menu-primary-menu li.close-container').on('click', function() {
                jQuery('.navbar-toggler').addClass('collapsed');
                jQuery('.navbar-toggler').attr('aria-expanded', 'false');
                jQuery('#collapseNav').removeClass('in');
                jQuery('#collapseNav').attr('aria-expanded', 'false');
            });
        }
        
        // for top nav menu hover states
        if (isMobile == false && windowWidth > 767) {
            $('.main-nav > li').mouseover(function() {
                $('.main-nav > li').removeClass('open');
                $(this).addClass('open');
            });
            $('.main-nav > li').mouseout(function() {
                $(this).removeClass('open');
            });
        }

        // Large mobile devices
        if (isMobile == true && windowWidth > 767) {
            $('.main-nav > li.dropdown > a').on('click', function(ex) {
                ex.preventDefault();
                if ($(this).parent().hasClass('open')) {
                    var link = $(this).attr('href');
                    window.location.href = link;
                } else {
                    $('.main-nav > li').each(function() {
                        $(this).removeClass('open');
                    });
                }
                $(this).parent().addClass('open');
            });

            $(document).on('click', function() {
                $('.main-nav > li').each(function() {
                    $(this).removeClass('open');
                });
            });
            $('.main-nav > li').click(function(event){
                event.stopPropagation();
            });
        }

        // resize functionality
        jQuery(window).resize(function() {
            console.log('test');
            var windowWidth = jQuery(window).innerWidth();
            setTimeout(function() {
                var columns = new Columns('.callout-row .callout-col p', '.callout-row .callout-col p');
                var columns2 = new Columns('.callout-row .callout-col h3', '.callout-row .callout-col h3');
                var columns3 = new Columns('.callout-row .callout-col', '.callout-row .callout-col');
                var managementBlue = new Columns('.management-row.management .info .info-name-title', '.management-row .info .info-name-title');
                var featuredBlue = new Columns('.management-row.featured .info .info-name-title', '.management-row.featured .info .info-name-title');
                // var columnsMobile = new Columns('.mobile .hp-col-set-height:visible', '.mobile .hp-col-match-height:visible');

                // columnsMobile.equalheight();
                columns.equalheight();
                columns2.equalheight();
                columns3.equalheight();
                managementBlue.equalheight();
                featuredBlue.equalheight();
            }, 1000);
            if (windowWidth < 768) {
                jQuery('#menu-primary-menu > li i').on('click', function() {
                    let $list = jQuery(this).siblings('ul');
                    let $parent = jQuery(this).parent().parent();
                    let $li = jQuery(this).parent();
                    showSubMenu($parent, $list, $li);
                });
                jQuery('#menu-primary-menu li.close-container').on('click', function() {
                    // ev.preventDefault();
                    jQuery('.navbar-toggler').addClass('collapsed');
                    jQuery('.navbar-toggler').attr('aria-expanded', 'false');
                    jQuery('#collapseNav').removeClass('in');
                    jQuery('#collapseNav').attr('aria-expanded', 'false');
                });
            }
        });

        // // window load
        jQuery(window).load(function() {
            
        });

        jQuery('.management-row .bio .close-btn').on('click', function() {
            jQuery(this).parent().hide();
        });

        jQuery('.contact-col .info-btn a').on('click', function() {
            let id = jQuery(this).attr('data-id');
            // console.log(id);
            jQuery('.bio').each(function() {
                jQuery(this).hide();
            });
            jQuery('#bio-'+id+'').show();
            jQuery("html, body").animate({scrollTop: $('#bio-'+id+'').offset().top }, 1000);
            // console.log('#bio-'+id+'');
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Common.js